export let foldersDiagnosticDataDescription = "QkWzk";
export default {foldersDiagnosticDataDescription};